function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function mergeTranslations(...sources: Record<string, unknown>[]): Record<string, unknown> {
  return sources.reduce<Record<string, unknown>>((accumulator, source) => {
    for (const [key, value] of Object.entries(source)) {
      const current = accumulator[key];
      if (isRecord(current) && isRecord(value)) {
        accumulator[key] = mergeTranslations(current, value);
      } else {
        accumulator[key] = value;
      }
    }
    return accumulator;
  }, {});
}
